goog.provide('el8.uiwidget.nestedListeditor');

goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.uiwidget.addDatepicker');
goog.require('el8.uiwidget.listeditor');
goog.require('el8.service.tz');
goog.require('el8.template.uiwidget.listeditor');
//
// NOTE: NLE has ambitions to be cleanly generic, but it's not yet. Various bits related to
// AOE data and the body site stuff will needed to be extracted and passed in. Also, #id use
// for labelsList and BodySites will need to be changed for multiple NLEs to exist on the page
//
//
// This is a subclass of listeditor that provides "nested" selection features used
// for various types of "ask on entry" questions for lab tests but not specific to the
// AOE use case. What "nesting" really means is that there are specific props on the
// LI "item/object" that we want to display in a certain way and want to extract with
// getAllEntries()
//
// **All the data must already be present** (we're not calling back to the server), but if there
// are 2 choices, we'll show radio buttons, otherwise we'll populate a mindreader.
//
// We'll also show and instanciate a date widget for labels with questionType === 'yyyymmdd'
// instead of a text input
//
// # FUTURE WORK:
//
// - data validation (will need to prevent getAllEntries() extraction)
// - populate from draft
//
// # HOW TO USE
//
// To use it send nestingSpec in the LEOpts:
//
// NOTE: multselect only works for enum types
//
// nestingSpec: {
//     // data
//     'labels': 'questions',
//
//     // metadata for each "label"
//     'labelType': 'questionType',
//     'labelValue': 'value',
//     'labelCode': 'code',
//     'choices': 'choices',
//     'choiceValue': 'value'
//     'choiceCode': 'code',
//     'maxLength': 'maxLength',
//     'responseValue': 'responseValue',
// }
//
// When used in a Form context, this will automatically create a NLE instead LE. All the methods
// used by Form are overridden below.
//
// # AOE USE CASE:
//
// Examples:
// - Labcorp: 192047 / Pap Lb, rfx HPV ASCU
//      - cytology
//      - CYTSRC: enum (multiselect)
//      - CYTCLT: enum (multi)
//      - CYTLMP: date
//      - ...
//      - CYTPRI: freetext
//
// - LabCorp: AFP, Serum, Open Spina Bifida (010801)
//      - INSULIN DEPENDENT: y_or_n
//      - WEIGHT (POUNDS): numeric 3
//      - GESTATIONAL AGE WEEKS: numeric 2
//      - GESTATIONAL AGE DAYS: numeric 1
//      - WEIGHT (OUNCES): numeric 2
//      - GESTATIONAL AGE IN DECIMAL FORM:  numeric 4
//      - GESTATIONAL AGE DATE OF CALCULATION: yyyymmdd
//      - GA CALCULATION METHOD: enum
//      - LMP DATE: yyyymmdd
//      ...
//      - ADDITIONAL INFORMATION: freetext
//      ...

el8.uiwidget.nestedListeditor = function(spec) {
    spec = spec || {};
    el8.uiwidget.listeditor.call(this, spec);
};
el8.uiwidget.nestedListeditor.inheritsFrom(el8.uiwidget.listeditor);

el8.uiwidget.nestedListeditor.prototype.init = function(var_args) {
    el8.uiwidget.listeditor.prototype.init.apply(this, arguments);
    this.showAOE = true;
    return this;
};

/**
 * we have cases where we don't want to show the AOE even if we have it. We'll let the
 * form dialog handle that logic.
 * Change whether we show AOEs or not
 *
 * @param {boolean} showAOE
 */
el8.uiwidget.nestedListeditor.prototype.setShowAOE = function(showAOE) {
    this.showAOE = showAOE;
};

el8.uiwidget.nestedListeditor.prototype.addEntry = function(item, doHighlight, async, notePerTest) {
    // addEntry (actually add or update) does a lot of the work of the widget:
    //
    // notePerTest: this is a Quest requirement where each test can have a free text note (NTE)
    //
    // - creates the actual HTML for the entry (_createEntry()) and appends it to the $listeditor
    // - populates the string value of the $entry (_populateEntry())
    // - sets the $entry's id attr
    // - adds $entry to idToEntryMap
    // - add the _item_ to the idToItemMap
    // - does some munging of the val() and heights
    // - then finally calls the callback addEntryFn()
    //
    // We override this here to add nesting
    //
    var CHOICES_RADIO_MAX = 3;
    el8.uiwidget.listeditor.prototype.addEntry.apply(this, arguments);
    var that = this;

    // Fetch the newly created entry from the map
    var $entry = this.idToEntryMap[item.getId()];

    //
    // Nested Entries
    //
    var spec = null;
    if (!this._opts.nestingSpec) { return this; }
    else { spec = this._opts.nestingSpec; }

    // Don't allow id-less strings
    if (typeof item === 'string') { return this; }

    var $firstNestedEntry = null;

    //
    // Breaking abstraction for LC histology tests...
    //
    if (this.showAOE && item.getProcedureClass() === 'HI') {
        el8.data.bodySiteCodes.softLoad();
        el8.data.bodySiteCodeModifiers.softLoad();

        var labelsName = 'BodySiteChunk';
        // Histology/cytology should only have one "question" corresponding to
        // SPMXXX for the body sites
        var responseValues = item.getQuestions()[0].getResponseValue().split('|');

        // Insert after the the $entry (<li>)
        var $labelsList = $(el8.template.uiwidget.listeditor.nestedlist({
            id: labelsName + '_' + item.getId()
        }));
        $entry.after($labelsList);

        var $addChunkTrigger = $(el8.template.uiwidget.listeditor.addBodySiteTrigger());
        $labelsList.append($addChunkTrigger);

        var addChunk = function(bodySiteCode, modifierCodes, description) {
            var numChunks = $('.body-site-chunk', $labelsList).length;
            if (numChunks === 40) { return; }
            numChunks += 1;
            var $newChunk = that._createBodySiteChunk(item.getId(), numChunks,
                                                      bodySiteCode, modifierCodes,
                                                      description);
            that._populateBodySiteFriendlyNames($newChunk);
            $newChunk.insertBefore($addChunkTrigger);
            return $newChunk;
        };
        $addChunkTrigger.on('click', '.add-part-trigger',  function() {
            addChunk('', [''], '');
        });

        responseValues.forEach(function(responseValue) {
            var descParts = responseValue.split('!', 2);
            var siteParts = descParts[0].split(':');
            var bodySite = siteParts[0];
            var modifiers = siteParts.slice(1);
            if (modifiers.length === 0) {
                modifiers.push('');
            }
            var description = descParts[1] || '';
            var $bodySiteChunk = addChunk(bodySite, modifiers, description);
            if (!$firstNestedEntry) { $firstNestedEntry = $bodySiteChunk; }
        });

        return this;
    } // end HI

    //
    // Dynamically create a new <li> skel -- this is analagous to $listcontainer for normal "items"
    //
    // For AOE: item here is a LabOrderTest and labels are AOEQuestions
    var labelsName = spec.labels;

    // If we're doing Quest we need to add a freetext question to the top of the list
    if (notePerTest) {
        var itemQuestions = item.getQuestions()
        var addNote = false;

        if (!itemQuestions.length) {
            addNote = true;
        } else {
            if (itemQuestions[0].getCode() !== el8.util.consts.NTE_PSEUDO_AOEQUESTION_CODE) {
                addNote = true;
            }
        }

        if (addNote) {
            itemQuestions.unshift({
                // Model is AOEQuestion
                choices: [],
                code: el8.util.consts.NTE_PSEUDO_AOEQUESTION_CODE,
                id: null,
                maxLength: 999,
                questionType: "freetext",
                responseValue: "",
                value: "NOTE"
            })
        }

        item.setQuestions(itemQuestions)
    }

    var labels = item.asSoyMap()[labelsName];

    if (this.showAOE) {
        // Insert an <ol> after the the $entry (<li>)
        var $labelsList = $(el8.template.uiwidget.listeditor.nestedlist({
            id: labelsName + '_' + item.getId()
        }));
        $entry.after($labelsList);

        //
        // Main stuff here
        //
        // - Insert <li>s from "labels" (e.g. AOE questions)
        // - Init MR if more than 2 enum choices
        // - Init datepicker if a date
        // - Fixed text radio if y or n
        //
        // item == LabOrderTest
        // labels == [questions]
        // dataIndex == index of test/item
        //
        _.each(labels, function(labelObj, idx) {
            var isRadio = labelObj[spec.choices].length < CHOICES_RADIO_MAX ? true : false;
            var choices = labelObj[spec.choices];
            var dataIndex = idx;
            var responseValues = [];
            var $nestedEntry = null;

            var _selectFn = function (obj) {
                if (labelObj[spec.labelType] === 'enum_multiselect') {
                    // Create below last sibling with the same code, only if it doesn't have a val
                    // var lastEntry = $('li[data-id="'+ item.getId() +'"]', $($labelsList)).last();
                    var lastEntry = $('li[data-id="'+ item.getId() +'"][data-code="'+labelObj[spec.labelCode]+'"]',$($labelsList)).last();
                    var lastEntryInput = $('input', lastEntry);
                    var lastIndex = lastEntry.data('index');

                    if (lastIndex > 1 && !lastEntryInput.val()) { return; }

                    var newLastIndex = lastIndex + 1;
                    var $newNestedEntry = $(el8.template.uiwidget.listeditor.nestedEntry({
                        dataId: item.getId(),
                        dataIndex: newLastIndex,
                        labelCode: labelObj[spec.labelCode],
                        labelValue: labelObj[spec.labelValue],
                        labelType: labelObj[spec.labelType],
                        choices: choices,
                        isRadio: isRadio,
                        maxLength: labelObj[spec.maxLength],
                        value: ''
                    }));

                    // Create below last entry
                    $newNestedEntry.insertAfter(lastEntry);

                    // attach MR (to the correct index)
                    var $input = $(':input[name="mr_' + item.getId()  +  '_' + newLastIndex +  '_' + labelObj[spec.labelCode] + '"]');
                    that._longChoicesListMR(choices, spec.labelValue, _selectFn).init($input);
                }
            };

            if (labelObj[spec.labelType] === 'enum_multiselect') {
                responseValues = labelObj[spec.responseValue].split('|');
                if (responseValues[responseValues.length - 1] !== '') {
                    // Ensure there's an open space to add more entries
                    responseValues.push('');
                }
            }
            else {
                responseValues = [labelObj[spec.responseValue]];
            }

            _.each(responseValues, function(responseValue) {
                if (labelObj[spec.labelType] === 'yyyymmdd' && responseValue !== '') {
                    // newTzDateTime doesn't parse 'yyyymmdd' format
                    // WHY do we even do this to ourselves
                    responseValue = el8.service.tz.newTzDateTime(
                        responseValue.slice(0, 4) + '/' +
                        responseValue.slice(4, 6) + '/' +
                        responseValue.slice(6)
                    ).asStringFormat(Date.format);
                }

                $nestedEntry = $(el8.template.uiwidget.listeditor.nestedEntry({
                    dataId: item.getId(),
                    dataIndex: dataIndex,
                    labelCode: labelObj[spec.labelCode],
                    labelValue: labelObj[spec.labelValue],
                    labelType: labelObj[spec.labelType],
                    choices: choices,
                    isRadio: isRadio,
                    maxLength: labelObj[spec.maxLength],
                    value: responseValue
                }));

                // Append to list
                $labelsList.append($nestedEntry);
                if (!$firstNestedEntry) { $firstNestedEntry = $nestedEntry; }

                // If more choices than CHOICES_RADIO_MAX, init mindreader
                if (choices && !isRadio) {
                    that._longChoicesListMR(choices, spec.labelValue, _selectFn).init($(':input[name="mr_' + item.getId() + '_' + dataIndex + '_' + labelObj[spec.labelCode] + '"]', $labelsList));
                }

                if (labelObj[spec.labelType] === 'yyyymmdd') {
                    var $input = $nestedEntry.find('input').first();
                    el8.uiwidget.addDatepicker(null, {
                        input: $input,
                        defaultDate: el8.service.tz.today()
                    });
                }

                dataIndex += 1;
            });
        });
    }

    // Focus the first entry/AOE if one exists
    _.defer(function() {
        if ($firstNestedEntry) { $('input', $firstNestedEntry).first().focusFocus(); }
    });

    this.addEntryFn();
    return this;
};

el8.uiwidget.nestedListeditor.prototype.removeEntry = function($entry, doDelete) {
    el8.uiwidget.listeditor.prototype.removeEntry.apply(this, arguments);
    // Also remove the nested entry container <ol>
    $('#'+this._opts.nestingSpec.labels+'_'+$entry.attr('_id')).remove();
    // And any body site chunks
    $('#BodySiteChunk_'+$entry.attr('_id')).remove();
};

el8.uiwidget.nestedListeditor.prototype.reset = function() {
    el8.uiwidget.listeditor.prototype.reset.apply(this, arguments);
};

el8.uiwidget.nestedListeditor.prototype.getMindreader = function() {
    return this.mindreader;
};

//
// Extraction
//
el8.uiwidget.nestedListeditor.prototype.getAllEntries = function() {
    // This thing really just returns items (e.g. labOrderTests) from the map while
    // finding and setting the nested values entered on the labelItem objects
    var result = [];
    var that = this;
    $('.le-entry', this.$listContainer).each(function() {
        var id = that._getEntryId($(this));
        var text = that._getEntryText($(this));
        var item = that.idToItemMap[id] || null;
        result.push({id: id, text: text, item: item});

        //
        // Nesting: For each item, essentially invert the above addEntry fn
        //
        var spec = null;
        if (!that._opts.nestingSpec) { return; }
        else { spec = that._opts.nestingSpec; }

        var labelsName = spec.labels;
        var labelItems = item['get'+labelsName.toUpperCamel()]();

        // Get enclosing the labels list
        var $labelsList = $('#'+labelsName + '_' + item.getId());

        // For each "label", get the "response"
        _.each(labelItems, function(labelItem) {
            if (item.getProcedureClass() !== 'HI') {
                var val = null;

                var $selection = $('li[data-code="'+ labelItem.getCode() +'"]',  $labelsList);

                if ($selection.length > 1) {
                    // multselect (enum only), pipe seperate and unpack in view
                    val = _.map($selection, function($li) { return $('input', $li).val(); }).join('|');
                } else {
                    val = $('input', $selection).val();

                    if ($selection.data('type') === 'yyyymmdd') {
                        // Convert mm/dd/yyyy to yyyymmdd
                        if (val) {
                            var d = el8.service.tz.toTzDate(val);
                            val = d.asStringFormat('yyyymmdd');
                        }
                    } else if ($selection.data('type') === 'y_or_n') {
                        val = $('input:checked', $selection).val();
                    }
                }

                // Set the returnValue
                labelItem['set'+spec.responseValue.toUpperCamel()](val);
            } else {
                //
                // Special case for BodySite stuff
                //
                // Going to use the same means to ship data back: AOEQuestion.responseValue.
                // All HI tests in the compendium have a single SOURCE AOE, so this should be ok
                //
                // packing:
                // sitecode1:modcode1:modcode2::description|sitecode2...|
                var chunkStrings = [];

                // Get enclosing the bodySiteChunk <ol>
                $labelsList = $('#BodySiteChunk' + '_' + item.getId());
                var chunks = $labelsList.find('.body-site-chunk');

                // Chunks are each <li>
                _.each(chunks, function(chunk) {
                    var val = '';
                    var modifiers = $(chunk).find('.modifier');
                    // var siteString = $(chunk).find('.site-input').val();
                    var siteString = $(chunk).data('selected-code');
                    if (!siteString) { return; }
                    var descString = $(chunk).find('.site-description').val();
                    var _tmpMods = _.map(modifiers, function(modifier) {
                        return $(modifier).data('selected-code');
                    });

                    _tmpMods = _.filter(_tmpMods, function (m) { return !!m; });
                    _tmpMods = _tmpMods.join(':');

                    val = siteString;
                    if (_tmpMods.length) { val += ':' + _tmpMods; }
                    if (descString) { val += '!' + descString; }
                    chunkStrings.push(val);
                });

                // Set the returnValue
                labelItem['set'+spec.responseValue.toUpperCamel()](chunkStrings.join('|'));
            }
        });
    });
    return result;
};

el8.uiwidget.nestedListeditor.prototype._createBodySiteChunk = function(dataId, dataIndex,
                                                                        bodySiteCode,
                                                                        modifierCodes,
                                                                        description) {
    var that = this;
    var $bodySiteChunk = $(el8.template.uiwidget.listeditor.bodySiteChunk({
        dataId: dataId,
        dataIndex: dataIndex,
        labelCode: 'site',
        labelValue: 'Site/Part ' + dataIndex,
        bodySiteCode: bodySiteCode,
        modifierCodes: modifierCodes,
        descriptionValue: description
    }));

    // bodySiteCodes MR
    (new el8.uiwidget.NewMindreader({
        data: _.sortBy(el8.data.bodySiteCodes.all(), 'code'),
        showOnFocus: true,
        rowToStringFn: this._formatBodySiteOrModifier,
        formatResult: this._formatBodySiteOrModifier,
        formatSelected: this._formatBodySiteOrModifier,
        selectFn: function (event, item) {
            $bodySiteChunk.data('selected-code', item.getCode());
        }
    })).init($(':input[name="mr_site_' + dataId + '_' + dataIndex + '"]', $bodySiteChunk));

    // bodySiteCodeModifiers MR
    $(':input.modifier-input', $bodySiteChunk).each(function() {
        that._bodySiteCodeModifierMR().init($(this));
    });

    // Add modifier trigger (up to 3 modifiers)
    $bodySiteChunk.on('click', '.add-modifier-trigger',  function(event) {
        var $leParent = $(event.target).closest('.le-content');
        if ($leParent.find('.modifier').length < 3) {
            var lastModifier = $leParent.find('.modifier').last();
            var lastModifierIndex = lastModifier.data('modifier-index') * 1;

            if (!$('input', lastModifier).val()) { return; }

            var $newModifier = $(el8.template.uiwidget.listeditor.modifier({
                dataId: dataId,
                dataIndex: dataIndex,
                dataModifierIndex: lastModifierIndex + 1,
                modifierCode: ''
            }));

            // Create below last entry
            $newModifier.insertAfter(lastModifier);

            // attach MR to new input
            var mr = that._bodySiteCodeModifierMR();
            mr.init($newModifier.find('input').first());
            $('.add-modifier-trigger-container', $leParent).show();
        }

        // Just added the 3rd, hide "+ modifier"
        if ($leParent.find('.modifier').length === 3) {
            $('.add-modifier-trigger-container', $leParent).hide();
        }
    });

    $bodySiteChunk.on('click', '.remove-modifier-trigger',  function(event) {
        var $modifier = $(event.target).closest('.modifier');
        $('.add-modifier-trigger-container', $modifier.closest('.le-nested-entry')).show();
        $modifier.remove();
    });

    $bodySiteChunk.on('click', '.remove-part-trigger',  function(event) {
        var $target = $(event.target);
        $($target).closest('.body-site-chunk').remove();
    });

    return $bodySiteChunk;
};

el8.uiwidget.nestedListeditor.prototype._populateBodySiteFriendlyNames = function($bodySiteChunk) {
    var that = this;
    var code = $bodySiteChunk.data('selected-code');
    var bodySite = el8.data.bodySiteCodes.getByKey(code);
    if (bodySite) {
        $('.site-input', $bodySiteChunk).val(that._formatBodySiteOrModifier(bodySite));
    }

    $('.modifier', $bodySiteChunk).each(function() {
        var code = $(this).data('selected-code');
        var modifier = el8.data.bodySiteCodeModifiers.getByKey(code);
        if (modifier) {
            $('.modifier-input', this).val(that._formatBodySiteOrModifier(modifier));
        }
    });
};

el8.uiwidget.nestedListeditor.prototype._formatBodySiteOrModifier = function(obj) {
    return obj.getCode() + ' ' + obj.getText().toUpperCase();
};

el8.uiwidget.nestedListeditor.prototype._bodySiteCodeModifierMR = function() {
    return new el8.uiwidget.NewMindreader({
        data: _.sortBy(el8.data.bodySiteCodeModifiers.all(), 'code'),
        showOnFocus: true,
        rowToStringFn: this._formatBodySiteOrModifier,
        formatResult: this._formatBodySiteOrModifier,
        formatSelected: this._formatBodySiteOrModifier,
        selectFn: function (event, item) {
            var $modifier = this.$inputField.closest('.modifier');
            $modifier.data('selected-code', item.getCode());
        }
    });
};

el8.uiwidget.nestedListeditor.prototype._longChoicesListMR = function(choices, sortField, selectFn) {
    var formatter = function(obj) { return obj.value.toUpperCase(); };

    return new el8.uiwidget.NewMindreader({
        data: _.sortBy(choices, sortField),
        showOnFocus: true,
        rowToStringFn: formatter,
        formatResult: formatter,
        formatSelected: formatter,
        selectFn: selectFn
    });
};
